export enum SubscriptionType {
  Monthly = 'monthly',
  Annual = 'annual',
}
